function e(t) {
  return t === "x" ? "y" : "x";
}
export {
  e as default
};
//# sourceMappingURL=getAltAxis.mjs.map
